var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-modal-window"},[_c('r-title',[_vm._v(_vm._s(_vm.title))]),_c(`modal-${_vm.mode}`,{tag:"component",attrs:{"source_id":_vm.source.source_id,"source":_vm.source},on:{"mode":_vm.changeMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }